function getRowsOfZeroes(size: number) {
  const row = [];
  for (let i = 0; i < size; i++) row.push(false);
  return row;
}
export default function createBoard(size: number): Boolean[][] {
  const board = [];
  for (let i = 0; i < size; i++) board.push(getRowsOfZeroes(size));
  return board;
}
